var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavIncidenciasActive = function SvgNavIncidenciasActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_incidencias_active_svg__Capa_2",
    viewBox: "0 0 32.55 31.92"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_incidencias_active_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.19 31.92h16.17c6.17 0 10.12-6.58 7.22-12.03L23.29 4.33c-3.11-5.84-11.52-5.76-14.51.15L.89 20.04c-2.76 5.44 1.2 11.87 7.3 11.87Z",
    fill: "#500d76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.71 24.37c-.33-.33-.49-.73-.49-1.21s.16-.88.49-1.21.73-.49 1.21-.49.85.16 1.17.49.48.73.48 1.21-.16.88-.48 1.21-.71.49-1.17.49-.88-.16-1.21-.49m2.53-13.95-.3 7.13h-2.09l-.3-7.13z",
    fill: "#fff"
  }))));
};
export default SvgNavIncidenciasActive;